import { Capacitor, registerPlugin } from "@capacitor/core";

// Bridge to the native CsvIntent plugin. Provides a no-op web fallback so the CRA
// build can run in browsers without Capacitor.
const CsvIntent = registerPlugin("CsvIntent", {
  web: () => ({
    addListener: async () => ({ remove: () => {} }),
  }),
});

export const listenForCsvIntent = (onPayload) => {
  const isCapacitorWeb = Capacitor.getPlatform() === "web";
  const pluginAvailable = Capacitor.isPluginAvailable("CsvIntent");

  if (isCapacitorWeb || !pluginAvailable) {
    return () => {};
  }

  const subscription = CsvIntent.addListener("csvIntent", (payload) => {
    console.log("[CsvIntent] Received payload from native bridge", payload);
    onPayload?.(payload);
  });

  return async () => {
    const handle = await subscription;
    handle?.remove?.();
  };
};
